export function menu(el) {
  const button = el.querySelector('.menu__button');
  const items = el.querySelectorAll('.menu__wrapper-inner > *');

  window.addEventListener('scroll', function() {
    el.removeAttribute('open');
  });

  window.addEventListener('wheel', function() {
    el.removeAttribute('open');
  });

  button.addEventListener('click', function() {
    el.toggleAttribute('open');
  });

  items.forEach(function(item) {
    item.addEventListener('click', function() {
      el.toggleAttribute('open');
    });
  });
}
